/* eslint-disable react/destructuring-assignment */
import { animated, useSpring } from "@react-spring/web";
import classNames from "classnames";
import { useEffect, useState } from "react";
import useMeasure from "react-use-measure";
import {
  CATEGORIES,
  CATEGORIES_ENUMS,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";
import CategoryNavigationItem from "components/atoms/CategoryNavigationItem";
import LoyaltyButton from "components/atoms/LoyaltyButton";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";
import { useSelector } from "react-redux";
import * as userSelector from "redux/user/selectors";
import CoinFestSidebar from "../CoinFestSidebar/CoinFestSidebar";

type CategoryNavigationProps = {
  isLoading: boolean;
  isSidebarOpen: boolean;
  onCategorySelect: (category: CATEGORIES_ENUMS) => void;
  hasLoyalty?: boolean;
};

const CategoryNavigation = (props: CategoryNavigationProps) => {
  const {
    isSidebarOpen,
    isLoading,
    onCategorySelect: handleCategorySelect,
    hasLoyalty = false,
  } = props;
  const [isOpen, setIsOpen] = useState(true);
  const [categoryRef, { height: heightElement }] = useMeasure();

  // eslint-disable-next-line unused-imports/no-unused-vars
  const { opacity } = useSpring({
    transform: `rotate(${isOpen ? 0 : -180}deg)`,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    height: isOpen ? heightElement : 0,
    opacity: isSidebarOpen ? 1 : 0,
  });

  const t = useTranslate();

  useEffect(() => {
    if (!isSidebarOpen) {
      setIsOpen(true);
    }
  }, [isSidebarOpen]);

  const popularClass = classNames("CategoryNavigation__popular", {
    short: !isSidebarOpen,
  });

  const currency = useSelector(userSelector.currency);
  const hasFirstDeposit = useSelector(userSelector.hasFirstDeposit);
  const isAvailableGeo =
    currency?.isoCode === "BDT" ||
    currency?.isoCode === "TRY" ||
    currency?.isoCode === "AZN" ||
    currency?.isoCode === "INR" ||
    currency?.isoCode === "KZT" ||
    currency?.isoCode === "UZS" ||
    currency?.isoCode === "PKR";

  return (
    <div className="CategoryNavigation">
      {`${import.meta.env.VITE_APP_PROJECT_NAME}` === "glory" &&
        hasFirstDeposit &&
        isAvailableGeo && <CoinFestSidebar isSidebarOpen={isSidebarOpen} />}
      {isLoading ? (
        <div className="CategoryNavigation__cat_loading" />
      ) : (
        <animated.div className="CategoryNavigation__title" style={{ opacity }}>
          {t("casino.providers.category")}
        </animated.div>
      )}
      <div>
        <animated.div ref={categoryRef}>
          <div className={popularClass}>
            {POPULAR_CATEGORIES.map((navigationItem) => (
              <CategoryNavigationItem
                key={navigationItem.id}
                item={navigationItem}
                isLoading={isLoading}
                isSidebarOpen={isSidebarOpen}
                onCategorySelect={handleCategorySelect}
              />
            ))}
            {hasLoyalty && (
              <LoyaltyButton
                isMini={!isSidebarOpen}
                className="CategoryNavigation__loyaltyButton"
              />
            )}
          </div>
          {CATEGORIES.map((navigationItem) => (
            <CategoryNavigationItem
              key={navigationItem.id}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              item={navigationItem}
              isLoading={isLoading}
              isSidebarOpen={isSidebarOpen}
              onCategorySelect={handleCategorySelect}
            />
          ))}
        </animated.div>
      </div>
    </div>
  );
};

export default CategoryNavigation;
